import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "skcp3k";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const skcp3kList = "Kepegawaian/SKCP3K/list/";
export const skcp3kCreate = "Kepegawaian/SKCP3K/create/";
export const skcp3kDetail = "Kepegawaian/SKCP3K/detail/";
export const skcp3kUpdate = "Kepegawaian/SKCP3K/update/";
export const skcp3kApprove = "Kepegawaian/SKCP3K/approve/";
export const skcp3kInactive = "Kepegawaian/SKCP3K/inactive/";
export const skcp3kActive = "Kepegawaian/SKCP3K/active/";

export const skcp3kRankList = "Kepegawaian/SKCP3K/rankList/";
export const skcp3kSignatories = "Kepegawaian/Penghargaan/signatories/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
